<template>
  <v-app id="app">
    <router-view/>
  </v-app>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch('getUsernameFromStorage')
  }
}
</script>

<style lang="less">
@import "assets/lufthansacolors.less";

.v-btn{
  .v-btn__content{
    color: white;
  }
}

* {
  margin: 0;
  border: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  color: #657180;
  overflow: hidden;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}
</style>
